import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import uiBox from 'client/shared/decorators/ui-box'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import { Heading } from 'client/shared/blocks/heading'
import Spacer from 'client/shared/blocks/spacer'
import Footer from 'client/shared/blocks/footer'

import './contacts-layout.styl'
import { Locale } from 'client/shared/types/current-user'

type Props = {
  locale: Locale
}

class _ContactsLayout extends Component<Props> {
  render(): JSX.Element {
    const businessLink = <a href="mailto:business@bookmate.com" />
    const corporateLink = <a href="mailto:sales@bookmate.com" />
    const supportLink = (
      <a href="https://intercom.help/bookmate-534438c41f4d/en/" />
    )
    const boldWrapper = <b />

    return (
      <LayoutColumn>
        <Spacer size="top-page" />
        <Heading kind="kazimir">
          <Trans id="contacts.title" />
        </Heading>
        <Spacer size={32} />
        <div className="contacts-layout">
          <Trans
            id="contacts.text"
            components={[
              businessLink,
              <span />,
              supportLink,
              <br />,
              corporateLink,
            ]}
          />
        </div>
        <Spacer size={32} />
        <div className="contacts-layout">
          <Trans id="contacts.address" components={[boldWrapper, <br />]} />
        </div>
        <Spacer size={80} />
        <Footer aboutMenu />
      </LayoutColumn>
    )
  }
}

export const ContactsLayout = uiBox(_ContactsLayout)
